/// <reference path="WebService.ts" />


interface WebService
{    
    uploadImage( file:File, context:any, completion:any ) : void ;
}

WebService.prototype.uploadImage = function( file:File, context:any, completion:any ) {

    let image_id = MIOUUID.UUID().UUIDString;
    let cmd = new WebServiceCommand(this.fileURL, "/" + this.scheme + "/upload-image/" + image_id);
    cmd.method = "PUT";
    cmd.blobData = file;

    cmd.execute(this, function (code, json) {
        if (completion != null)
            completion(code, json["data"], image_id, context);
    });
}

